import { img, pageImages } from './siteData';

export const shopConditions = ['New', 'Used', 'Refurbished'];

export const shopTypes = [
  'Horizontal Automatic',
  'Wide-Mouth Automatic',
  'Full-Eject',
  'Manual Tie',
  'Material Handling',
  'Vertical Press',
];

export const shopInventory = [
  {
    id: 'cm-auto-001',
    title: 'Open-End Automatic Tie Horizontal Baler',
    condition: 'New',
    type: 'Horizontal Automatic',
    image: img(pageImages['open-end-automatic-tie-balers'][0]),
    price: 'Request Quote',
    lead: 'Automatic wire tying for steady paper, OCC, non-woven, and industrial by-product streams.',
    specs: ['Auto-tie system', 'Conveyor-ready hopper', 'Heavy-duty frame'],
    href: '/open-end-automatic-tie-balers',
  },
  {
    id: 'cm-wide-002',
    title: 'Wide-Mouth Auto-Tie Baler With Conveyor Infeed',
    condition: 'New',
    type: 'Wide-Mouth Automatic',
    image: img(pageImages['wide-mouth-open-end-automatic-tie-balers'][0]),
    price: 'Request Quote',
    lead: 'Wide infeed opening for bulky cartons, trim, and loose material that needs room to drop cleanly.',
    specs: ['Wide-mouth opening', 'Automatic tying', 'Production-line feed'],
    href: '/wide-mouth-open-end-automatic-tie-balers',
  },
  {
    id: 'cm-full-003',
    title: 'Full-Eject Closed-End Multi-Material Baler',
    condition: 'Refurbished',
    type: 'Full-Eject',
    image: img(pageImages['multi-materials-full-eject-closed-end-balers'][0]),
    price: 'Call For Pricing',
    lead: 'Full bale ejection for changing grades, fibers, plastics, and materials with heavy springback.',
    specs: ['Full bale ejection', 'Grade separation', 'Difficult-material fit'],
    href: '/multi-materials-full-eject-closed-end-balers',
  },
  {
    id: 'cm-closed-004',
    title: 'Closed-End Manual Tie Industrial Baler',
    condition: 'Used',
    type: 'Manual Tie',
    image: img(pageImages['closed-end-manual-tie-balers'][0]),
    price: 'Call For Pricing',
    lead: 'Practical manual-tie horizontal baler for warehouses, plants, and recycling operations.',
    specs: ['Manual wire or strap', 'Closed-end chamber', 'Industrial duty'],
    href: '/closed-end-manual-tie-balers',
  },
  {
    id: 'cm-conveyor-005',
    title: 'Conveyor Fed Baling System',
    condition: 'New',
    type: 'Material Handling',
    image: img(pageImages['conveyors-bale-conveying-bagging-systems'][0]),
    price: 'Request Quote',
    lead: 'Integrated conveyor and baler package for smoother collection, loading, and bale discharge.',
    specs: ['Infeed conveyor', 'Bale handling', 'System controls'],
    href: '/conveyors-bale-conveying-bagging-systems',
  },
  {
    id: 'cm-vertical-006',
    title: 'Vertical Down-Packing Baling Press',
    condition: 'Used',
    type: 'Vertical Press',
    image: img(pageImages['vertical-down-packing-baling-presses-balers'][0]),
    price: 'Call For Pricing',
    lead: 'Compact vertical press option for lower-volume cardboard, paper, and packaging applications.',
    specs: ['Small footprint', 'Down-stroke press', 'Mill-size bale options'],
    href: '/vertical-down-packing-baling-presses-balers',
  },
  {
    id: 'cm-manual-007',
    title: 'Open-End Manual Tie Baler For Production Areas',
    condition: 'Refurbished',
    type: 'Manual Tie',
    image: img(pageImages['open-end-manual-tie-balers'][0]),
    price: 'Call For Pricing',
    lead: 'Lower-cost horizontal baling for applications that need open-end extrusion resistance.',
    specs: ['Open-end chamber', 'Manual tie', 'Medium production'],
    href: '/open-end-manual-tie-balers',
  },
  {
    id: 'cm-cart-008',
    title: 'Cart Dumper And Baler Loading Package',
    condition: 'New',
    type: 'Material Handling',
    image: img(pageImages['cart-lifters-dumpers-dump-carts'][0]),
    price: 'Request Quote',
    lead: 'Cart lifting and dumping equipment configured around C&M balers and collection workflows.',
    specs: ['Cart lifter', 'Guarded dump cycle', 'Hydraulic package'],
    href: '/cart-lifters-dumpers-dump-carts',
  },
];
